import React from 'react'

function ArrowRightIcon(props) {
  return (
    <svg
      width='24'
      height='52'
      viewBox='0 0 24 52'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M1.00049 51L22.2126 26.7576L1.00049 1'
        stroke='#003D87'
        strokeWidth='2'
      />
    </svg>
  )
}

export default ArrowRightIcon
